import { styled as muiStyled, css } from '@mui/material/styles';
import React from 'react';
import { useLocation } from 'react-router-dom';

import { useDashboardDataContext } from './dashboard/dashboard-context';
import { DesignToken } from '../base/core';
import Text from '../base/text';

import * as GQL from '~/graphql/generated/client';

interface Props {
  className?: string;
}
const ProjectDisplayNameImpl: React.FC<Props> = ({ className }) => {
  const location = useLocation();
  const { pathname } = location;
  const { project } = useDashboardDataContext();

  // Check if project is organization type (from context)
  const isOrganization = project?.projectType === GQL.ProjectType.Organization;

  const getDisplayName = () => {
    // Use project type when available for accurate display
    if (project?.projectType === GQL.ProjectType.Dataset) {
      return 'Dataset';
    }

    // Check for candidate model
    if (pathname.includes('/candidate-model/')) {
      return 'Models';
    }

    // Check for candidate agent
    if (pathname.includes('/candidate-agent/')) {
      return 'Agents';
    }

    // Check for functional model
    if (pathname.includes('/ai-usecase/')) {
      return 'AI USE CASE';
    }

    // Default to AI System - check if organization context
    if (pathname.includes('/ai-system/')) {
      return isOrganization ? 'ORGANIZATION' : 'PROJECT';
    }

    return ''; // Fallback empty string
  };
  return (
    <div className={className}>
      <Text sz="bold-body14" color={DesignToken.brand.primaryContrast}>
        {getDisplayName()}
      </Text>
    </div>
  );
};
export const ProjectDisplayName = muiStyled(ProjectDisplayNameImpl)(() => {
  return css`
    & div {
      text-align: left;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  `;
});
